<template lang="pug" id="bar">
extends ./Base.pug
</template>

<script>
import BaseChart from './Base.vue';
import * as d3 from 'd3';
import has from 'lodash/has';

export default {
  extends: BaseChart,
  name: 'aiqBarChart',
  methods: {
    getChartType() {
      return 'bar';
    },

    getChartAutoColors() {
      try {
        const cached = localStorage.getItem(this.getAutoColorAssignKey());
        return cached ? JSON.parse(cached) : [];
      } catch (error) {
        return [];
      }
    },

    saveChartAutoColors(colors) {
      localStorage.setItem(this.getAutoColorAssignKey(), JSON.stringify(colors));
    },

    getAutoColorAssignKey() {
      if (has(this.graphParams, 'autoColorAssignKey')) {
        return `bar_chart_auto_colors_${this.graphParams.autoColorAssignKey}`;
      }

      return null;
    },

    getLineColor(line) {
      const lineColor = BaseChart.methods.getLineColor.call(this, line);

      if (!lineColor && this.getAutoColorAssignKey() && line.label) {
        const barChartColors = d3.schemeCategory10;
        const colorKey = line.label.toLowerCase();

        // Get auto colors from localStorage
        const autoColors = this.getChartAutoColors();
        const targetColor = autoColors.find(row => row.key === colorKey);

        if (targetColor) {
          return targetColor.color;
        }
        else {
          const newColorIndex = autoColors.length % barChartColors.length;
          const newColor = { key: colorKey, color: barChartColors[newColorIndex] };
          autoColors.push(newColor);

          // Save updated colors to localStorage
          this.saveChartAutoColors(autoColors);

          return barChartColors[newColorIndex];
        }
      }

      return lineColor;
    },
  },
};
</script>

<style lang="scss">
</style>